import { React, useEffect, useState } from "react";
import { getEpisodesByWeek } from "@store/action/planning/EpisodeAction";
import { useDispatch, useSelector } from "react-redux";

const ShowSchedule = ({ t }) => {
  var now = new Date();
  var days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  var dayNow = days[now.getDay() === 0 ? 6 : now.getDay() - 1];
  const [day, setDay] = useState(dayNow);
  const dispatch = useDispatch();
  const episodes = useSelector((state) => state.episodes).data;
  console.log("episodes[day]", episodes[day]);
  const getEpisodes = () => {
    return episodes[day]?.map((item, i) => (
      <div className="col-sm-6 col-md-4 col-lg-3" key={i}>
        <div className="UshnoCardShow show-card">
          <div className="show-content">
            <div
              className="show-bg"
              style={{
                height: "150px",
              }}
            >
              <img width="100%" height="150px" src={item.name} alt="show-1" />
            </div>
            <div className="show-overlay">
              <div className="show-time">
                <p>{item.start_datetime}</p>
                <h4>Emission: {item.emission.name}</h4>
                <h4>Episode: {item.name}</h4>
              </div>
              {/* <ul className="show-host">
                <li>
                  <a>
                    <img src={host1} alt="host-1" />
                  </a>
                </li>
                <li>
                  <a>
                    <img src={host2} alt="host-2" />
                  </a>
                </li>
                <li>
                  <a>
                    <img src={host3} alt="host-3" />
                  </a>
                </li>
              </ul> */}
            </div>
          </div>
        </div>
      </div>
    ));
  };
  useEffect(() => {
    dispatch(getEpisodesByWeek());
  }, []);
  useEffect(() => {
    const show_menu = document.getElementsByClassName("nav-link");
    show_menu[now.getDay() === 0 ? 7 : now.getDay()].className += " active";
  }, []);

  return (
    <div className="ShowScheduleUshno">
      <section className="section show-part">
        <div className="container__">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-heading">
                <h2>{t("Schedule")}</h2>
              </div>
            </div>
          </div>

          <div className="container__video">
            <div className="row">
              <div className="col-lg-12">
                <div id="show-menu">
                  <ul className="nav nav-tabs">
                    {days.map((el) => (
                      <li>
                        <a
                          className="nav-link"
                          data-bs-toggle="tab"
                          onClick={() => setDay(el)}
                        >
                          {t(el)}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="tab-pane active">
                  <div className="row">
                    {getEpisodes()?.length > 0 ? (
                      getEpisodes()
                    ) : (
                      <p
                        style={{
                          textAlign: "center",
                          margin: "120px 0",
                        }}
                      >
                        {t("No episode schedule today")}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="row">
              <div className="col-lg-12">
                <div className="show-btn">
                  <Link className="btn btn-outline" to="/schedule">
                    <i className="fa fa-eye me-1"></i>
                    <span>{t("show more")}</span>
                  </Link>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ShowSchedule;
